import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { AppointmentService } from 'src/app/services/appointment.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { PatientPersonalInfo, VerifypatientModule } from 'src/app/models/verifypatient/verifypatient';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import moment from 'moment';
import { type } from 'os';
import { IntakeMedicationService } from '../../services/intake-Medication.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-finalappointmentmessage',
  templateUrl: './finalappointmentmessage.component.html',
  styleUrls: ['./finalappointmentmessage.component.css']
})
export class FinalappointmentmessageComponent implements OnInit {

  patientpersonalinfo: any;
  patientpersonalinfoCheckin: any;
  appointment_details: any;
  isWithin24Hours: any;
  isWithin3Hours: any;
  VerifypatientModule = new VerifypatientModule();
  appointmentAddress: any;
  appointmentState: any;
  appointmentCity: any;
  appointmentZip: any;
  IslandeFromQRCode: boolean = false;
  selectedLanguage: any = 'en';
  currentLang: any = 'en';
  Provider: any;
  isForReschedule: boolean = false;
  isAfterCancel: boolean = false;
  isFromcheckin: boolean = false;
  isFromnewPatient: boolean = false;
  isFromAppointment: boolean = false;
  ProviderName: any;
  isRtl: boolean = false;
  isDrsite: boolean = false;
  appointmentEndDate: any;
  appointmentEndTime: any;
  appointmentDate: any;
  constructor(private location: Location, private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private appoint: AppointmentService, private datepipe: DatePipe, private _registor: RegistorpatientService
    , private _router: Router, private _VerifypatientService: VerifypatientService, private updateinfoservice: UpdateinfoService, private medicationService: IntakeMedicationService, private translateService: TranslateService) {
    let checkinFrom = localStorage.getItem('landFrom');
    //console.log("checkinFrom chk", checkinFrom);
    this.isForReschedule = (checkinFrom === "checkin_reschedule");
    this.isAfterCancel = (checkinFrom === "checkin_cancel");
    this.isFromcheckin = (checkinFrom === "check-in");
    this.isFromnewPatient = (checkinFrom === "new_patient");
    this.isFromAppointment = (checkinFrom == 'drsiteintake' || checkinFrom == 'drsite');
    if (checkinFrom == 'drsite') {
      this.isDrsite = true;
    } else {
      this.isDrsite = false;
    }
    //console.log("reschdeule", this.isForReschedule);
    //console.log("cancel", this.isAfterCancel);
    if (this.isForReschedule || this.isAfterCancel) {
      //console.log("is reschdeule");
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
    }
    // else if (checkinFrom == 'drsiteintake' || checkinFrom == 'drsite') {
    else if (checkinFrom == 'drsiteintake') {
      //console.log("is Appointment");
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
      //this.isFromcheckin = false;
    }
    else {
      //console.log("normal flow");
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
    }

  }

  ngOnInit(): void {
    const providerData = localStorage.getItem('rescheduleProvider');
    //console.log('Selected Provider:', providerData);
    if (providerData) {
      this.Provider = JSON.parse(providerData); // Parse the JSON string
      this.ProviderName = this.Provider.providerName; // Access providerName
    }

    //console.log("Provider", this.Provider);
    //console.log("Provider Name", this.ProviderName);
    if (this.isForReschedule || this.isAfterCancel) {
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));

    } else {
      this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
      //console.log("personal info", this.patientpersonalinfo);
    }

    const checkinDetails = localStorage.getItem('PatientInfoCheckin');
    //console.log("checkinDetails", checkinDetails);
    if (checkinDetails != null && checkinDetails != undefined) {
      if (this.isForReschedule || this.isAfterCancel) {
        //console.log("is reschdeule or cancel");
        this.isFromcheckin = false;
      }
      else if (this.isFromAppointment) {
        //console.log("is from appointment");
        this.isFromcheckin = false;
      }
      else if (this.isFromnewPatient) {
        //console.log("is from new patient");
        this.isFromcheckin = false;
      }
      else {
        //console.log("is not reschdeule or cancel");
        this.isFromcheckin = true;
      }
      if (!this.isForReschedule && !this.isAfterCancel && this.isFromcheckin) {
        //console.log("cancel and reschedule");
        this._phrutilService.patientlanguage$.subscribe(language => {
          // //console.log("dafault " + language);
          if (language === 'es') {
            this.currentLang = language;
            this._phrutilService.setTitle('Regístrese para una cita');
          } else if (language === 'hi') {
            this.currentLang = language;
            this._phrutilService.setTitle('अपॉइंटमेंट के लिए चेक-इन करें');
          } else if (language === 'ur') {
            this.currentLang = language;
            this._phrutilService.setTitle('اپوائنٹمنٹ کے لیے چیک ان کریں');
          } else if (language === 'gu') {
            this.currentLang = language;
            this._phrutilService.setTitle('એપોઇન્ટમેન્ટ માટે ચેક-ઇન કરો');
          }
          else {
            this.currentLang = 'en';
            this._phrutilService.setTitle('Check-in for Appointment');
          }
        });
      }
      else if (this.isForReschedule) {
        this._phrutilService.patientlanguage$.subscribe(language => {
          if (language === 'es') {
            this.isRtl = false;
            this._phrutilService.setTitle('Reprogramar una cita');
          } else if (language === 'hi') {
            this.isRtl = false;
            this._phrutilService.setTitle('अपॉइंटमेंट पुनः निर्धारित करें');
          } else if (language === 'ur') {
            this.isRtl = true;
            this._phrutilService.setTitle('اپوائنٹمنٹ دوبارہ شیڈول کریں');
          } else if (language === 'gu') {
            this.isRtl = false;
            this._phrutilService.setTitle('એપોઇન્ટમેન્ટ ફરીથી શેડ્યૂલ કરો');
          }
          else {
            this.isRtl = false;
            this._phrutilService.setTitle('Reschedule Appointment');
          }
        });
      }
      else if (this.isFromAppointment || this.isFromnewPatient) {
        this._phrutilService.patientlanguage$.subscribe(language => {
          //  //console.log("dafault " + language);
          if (language === 'es') {
            this.currentLang = language;
            this._phrutilService.setTitle('Reservar una cita');
          } else if (language === 'hi') {
            this.currentLang = language;
            this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
          } else if (language === 'ur') {
            this.currentLang = language;
            this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
          } else if (language === 'gu') {
            this.currentLang = language;
            this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
          }
          else {
            this.currentLang = 'en';
            this._phrutilService.setTitle('Book an Appointment');
          }
        });
      }
      else {
        this._phrutilService.patientlanguage$.subscribe(language => {
          //  //console.log("dafault " + language);
          if (language === 'es') {
            this.currentLang = language;
            this._phrutilService.setTitle('Reservar una cita');
          } else if (language === 'hi') {
            this.currentLang = language;
            this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
          } else if (language === 'ur') {
            this.currentLang = language;
            this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
          } else if (language === 'gu') {
            this.currentLang = language;
            this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
          }
          else {
            this.currentLang = 'en';
            this._phrutilService.setTitle('Book an Appointment');
          }
        });
      }
      this.patientpersonalinfoCheckin = this._phrutilService.decrypt(checkinDetails);
      ////console.log(this.patientpersonalinfoCheckin);
      this.appointmentAddress = this.patientpersonalinfoCheckin.appointmentAddress ? this.patientpersonalinfoCheckin.appointmentAddress : this.patientpersonalinfoCheckin.practiceAddress;
      this.appointmentState = this.patientpersonalinfoCheckin.appointmentState ? this.patientpersonalinfoCheckin.appointmentState : this.patientpersonalinfoCheckin.practiceState;
      this.appointmentCity = this.patientpersonalinfoCheckin.appointmentCity ? this.patientpersonalinfoCheckin.appointmentCity : this.patientpersonalinfoCheckin.PracticeCity;
      this.appointmentZip = this.patientpersonalinfoCheckin.appointmentZip ? this.patientpersonalinfoCheckin.appointmentZip : this.patientpersonalinfoCheckin.praticeZip;
      localStorage.setItem("apptAddr", this.appointmentAddress);
      localStorage.setItem("apptst", this.appointmentState);
      localStorage.setItem("apptcty", this.appointmentCity);
      localStorage.setItem("aptzip", this.appointmentZip);
    } else {
      this._phrutilService.patientlanguage$.subscribe(language => {
        //  //console.log("dafault " + language);
        if (language === 'es') {
          this.currentLang = language;
          this._phrutilService.setTitle('Reservar una cita');
        } else if (language === 'hi') {
          this.currentLang = language;
          this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
        } else if (language === 'ur') {
          this.currentLang = language;
          this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
        } else if (language === 'gu') {
          this.currentLang = language;
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
        }
        else {
          this.currentLang = 'en';
          this._phrutilService.setTitle('Book an Appointment');
        }
      });
    }
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.firstName != undefined && this.patientpersonalinfoCheckin.firstName != null) {
      this.patientpersonalinfo.first_Name = this.patientpersonalinfoCheckin.firstName;
    }
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.lastName != undefined && this.patientpersonalinfoCheckin.lastName != null) {
      this.patientpersonalinfo.last_Name = this.patientpersonalinfoCheckin.lastName;
    }
    ////console.log(this.patientpersonalinfoCheckin);
    ////console.log(this.patientpersonalinfo);
    // //console.log("this is patient_Account console " + this.patientpersonalinfo.patient_Account)
    this.getAppointmentDetails();
    if (this.isFromcheckin == true) {
      //console.log("is from checkin");
      this.checkinthroughexiting();
    }
    const landfrom = localStorage.getItem("landFrom");
    if (landfrom != undefined && landfrom != null && landfrom == 'qrcode') {
      this.IslandeFromQRCode = true;
      this._phrutilService.setTitle('Verify Patient');
      this._phrutilService.setNavpracName(this.patientpersonalinfoCheckin.practiceName);
      $("#language-modal").modal("show");
    }
    //if (this.isForReschedule) {
    //  localStorage.removeItem('landFrom');
    //}
  }

  backPage() {
    this.location.back();
  }

  selectLanguage(language: string) {
    this.selectedLanguage = language;
    this.currentLang = language;
    this.onLanguageChange();

  }
  onLanguageChange() {
    this.translateService.use(this.selectedLanguage)
    localStorage.setItem('language', this.selectedLanguage);
    // //console.log("lang verify modal " + this.selectedLanguage);
    this._phrutilService.setdeafultLanguage(this.selectedLanguage);
    this._phrutilService.setPatientLanguage(this.selectedLanguage);
    this._phrutilService.setTitle('Verify Patient');
    this._phrutilService.setNavpracName(this.patientpersonalinfoCheckin.practiceName);
    this.currentLang = this.selectedLanguage;
    $("#language-modal").modal("hide");
    ////console.log("onLanguageChange");
  }

  phoneLink: any;
  getAppointmentDetails() {
    //  //console.log("check-in",this.patientpersonalinfoCheckin)
    // //console.log("practicecode", this.patientpersonalinfo.practice_Code)
    // //console.log("practicecode", this.patientpersonalinfo.patient_Account)
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.practiceCode != undefined && this.patientpersonalinfoCheckin.practiceCode != null) {
      this.patientpersonalinfo.practice_Code = this.patientpersonalinfoCheckin.practiceCode;
    }
    if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.patientAccount != undefined && this.patientpersonalinfoCheckin.patientAccount != null) {
      this.patientpersonalinfo.patient_Account = this.patientpersonalinfoCheckin.patientAccount;
    }
    if (!this.isAfterCancel) {
      if (this.patientpersonalinfoCheckin && this.patientpersonalinfoCheckin.appointment_id != undefined && this.patientpersonalinfoCheckin.appointment_id != null) {
        this.patientpersonalinfo.appointmentid = this.patientpersonalinfoCheckin.appointment_id;
      }
    }

    this.spinner.show();
    this.appoint.getAppointmentDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account, this.patientpersonalinfo.appointmentid).subscribe((res: any) => {
      this.spinner.hide();
      if (res.statusCode == 200) {
        this.appointment_details = res.data;
        this.ProviderName = this.appointment_details.provid_FName + ' ' + this.appointment_details.provid_LName;
        this.appointment_details.praC_PHONE = this._phrutilService.maskingPhoneNumer(this.appointment_details.praC_PHONE);
        this.ProviderName = this.appointment_details.provid_FName + ' ' + this.appointment_details.provid_LName;
        // Original date string
        const appointmentDateTimeString = this.appointment_details.appointment_Date_Time;
        const appointmentDateTime = new Date(appointmentDateTimeString);
        this.appointmentDate = appointmentDateTime.toLocaleDateString();
        //console.log(this.appointmentDate);
        const appointmentEnddateTime: any = this.appointment_details.appointment_End_DateTime;
        //console.log("end date and time ", appointmentEnddateTime);
        const appointmentStartdateTime: any = localStorage.getItem('visitDate');
        //console.log("end date and time ", appointmentEnddateTime);
        //console.log("start date and time ", appointmentStartdateTime);
        // Split the string by the space to separate date and time
        if (!appointmentEnddateTime) {
          //console.log("inside ", appointmentEnddateTime);
        } else {
          //console.log("inside else end date", appointmentEnddateTime);

          // Regex to capture date and time (without seconds)
          const splitParts = appointmentEnddateTime.match(/^([\d\/]+)\s(\d{1,2}:\d{2}):\d{2}\s?([AP]M)$/i);

          if (splitParts && splitParts.length === 4) {
            this.appointmentEndDate = splitParts[1];              // Date part, e.g. "7/22/2025"
            this.appointmentEndTime = `${splitParts[2]} ${splitParts[3]}`;  // Time without seconds, e.g. "2:15 PM"
          } else {
            //console.log("Date-time format didn't match!");
          }
        }

        //// Split the string by the space to separate date and time
        //if (appointmentEnddateTime == null || appointmentEnddateTime == '' || appointmentEnddateTime == undefined) {
        //  //console.log("inside ", appointmentEnddateTime);
        //} else {
        //  //console.log("inside else end date", appointmentEnddateTime);
        //  const splitParts = appointmentEnddateTime.match(/(.+)\s(\d{1,2}:\d{2}:\d{2}\s?(AM|PM)?)/);

        //  if (splitParts && splitParts.length === 4) {
        //    this.appointmentEndDate = splitParts[1]; // Captures the date part
        //    this.appointmentEndTime = splitParts[2]; // Captures the time with AM/PM
        //  }
        //}
        //if (appointmentStartdateTime == null || appointmentStartdateTime == '' || appointmentStartdateTime == undefined) {
        //  //console.log("inside ", appointmentStartdateTime);
        //} else {
        //  //console.log("inside else start date", appointmentStartdateTime);
        //  this.appointmentStartDate = appointmentStartdateTime;
        //}
        this.appointment_details.praC_ZIP = this.appointment_details.praC_ZIP.length > 5 ? this._phrutilService.maskingZipNum(this.appointment_details.praC_ZIP) : this.appointment_details.praC_ZIP;
        if (this.appointment_details?.praC_PHONE) {
          this.phoneLink = "tel:+1" + this.appointment_details?.praC_PHONE;
        }
        if (this.isFromcheckin != true) {
          //this.appointmentAddress = this.appointment_details.praC_ADDRESS;
          //this.appointmentState = this.appointment_details.praC_STATE;
          //this.appointmentCity = this.appointment_details.praC_CITY;
          //this.appointmentZip = this.appointment_details.praC_ZIP;
          this.appointmentAddress = this.appointment_details.appointment_Address ? this.appointment_details.appointment_Address : this.appointment_details.praC_ADDRESS;
          this.appointmentState = this.appointment_details.appointment_State ? this.appointment_details.appointment_State : this.appointment_details.praC_STATE;
          this.appointmentCity = this.appointment_details.appointment_City ? this.appointment_details.appointment_City : this.appointment_details.praC_CITY;
          this.appointmentZip = this.appointment_details.appointment_Zip ? this.appointment_details.appointment_Zip : this.appointment_details.praC_ZIP;
          localStorage.setItem("apptAddr", this.appointmentAddress);
          localStorage.setItem("apptst", this.appointmentState);
          localStorage.setItem("apptcty", this.appointmentCity);
          localStorage.setItem("aptzip", this.appointmentZip);
          if (this.appointment_details.appointment_Date_Time == null || this.appointment_details.appointment_Date_Time == '' || this.appointment_details.appointment_Date_Time == undefined) {
            //console.log("inside ", this.appointment_details.appointment_Date_Time);
          } else {
            //console.log("inside else end date", this.appointment_details.appointment_Date_Time);

            const splitParts = this.appointment_details.appointment_Date_Time.match(/(.+)\s(\d{1,2}:\d{2}:\d{2}\s?(AM|PM)?)/);

            if (splitParts && splitParts.length === 4) {

              const appointmentStartDate = splitParts[1]; // Captures the date part

              // this.appointmentEndTime = splitParts[2]; // Captures the time with AM/PM

              localStorage.setItem("visitDate", appointmentStartDate);

            }
          }
          localStorage.setItem("apptEndTime", this.appointment_details.appointment_End_DateTime);
        }
      }
    }, (error: any) => {
      this.spinner.hide();
    })
  }
  checkin() {
    //console.log("isdataScienceCallFailed", this.isdataScienceCallFailed);
    //console.log("checkin");
    if (this.isdataScienceCallFailed) {
      this.checkinthroughexiting();
    } else {
      //console.log("checkin");
      this._router.navigateByUrl('/patient/consent-form');
    }

  }
  checkinAfterReschedule() {
    this._router.navigateByUrl('/patient/consent-form');
  }
  isdataScienceCallFailed: boolean = false;
  checkinthroughexiting() {
    this.spinner.show();
    /*  alert(this.patientpersonalinfo.date_Of_Birth);*/
    this.VerifypatientModule.PRACTICE_CODE = this.patientpersonalinfoCheckin.practiceCode;
    //this.VerifypatientModule.PRACTICE_CODE = '1011163';
    this.VerifypatientModule.LAST_NAME = this.patientpersonalinfoCheckin.lastName;
    this.VerifypatientModule.FIRST_NAME = this.patientpersonalinfoCheckin.firstName;
    this.VerifypatientModule.DOB = this.datepipe.transform(this.patientpersonalinfoCheckin.dateOfBirth, 'MM/dd/yyyy');
    this.VerifypatientModule.APPOINTMENT_ID = this.patientpersonalinfoCheckin.appointment_id;
    /*  alert(this.VerifypatientModule.DOB);*/
    this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule)
      .pipe(
        catchError((error) => {
          this.spinner.hide();
          if (error.status === 0) {
            //console.error('Network error or CORS issue.');
            // Handle network error or CORS issue specifically
            /* alert("Network error or CORS issue.");*/
          } else {
            //console.error('An error occurred:', error);
            /*  alert(error);*/
          }
          this.isdataScienceCallFailed = true;
          return of(null); // Return a null observable to gracefully handle the error
        })
      ).subscribe((res: any) => {

        this.spinner.hide();
        if (res.RESPONSE[0]) {

          let PatientPersonalInfo = res.RESPONSE[0] as PatientPersonalInfo;
          PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
          PatientPersonalInfo.isShowpicture = true;
          PatientPersonalInfo.PracticeName = this.patientpersonalinfo.practice_name;
          PatientPersonalInfo.PROVIDER_CODE = this.patientpersonalinfoCheckin.providerCode;
          let data = this._phrutilService.encrypt(PatientPersonalInfo);
          localStorage.setItem('PersonalInfo', data);
          localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
          this.updateinfoservice.onIsShowProfilePic();
          this._VerifypatientService.startRefreshTokenTimer();
          if (this.isdataScienceCallFailed) {
            this._router.navigateByUrl('/patient/consent-form');
          }
        } else {
          $("#incorrectinfo-model").modal("show");
        }
      }, (error: any) => {
        //alert(error);
        ////console.log(error+"error");
        // $("#incorrectinfo-model").modal("show");
        this.spinner.hide();
        this.isdataScienceCallFailed = true;
      })
  }


  getCurrentDateFormatted(): string {
    const currentDate = this.ConverttoLocalDate(new Date());
    //console.log("current date before format " + currentDate);
    const month = currentDate.getMonth() + 1; // Months are zero-based
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
  }
  getNextDayFormatted(): any {
    const currentDate = this.ConverttoLocalDate(new Date());
    currentDate.setDate(currentDate.getDate() + 1); // Add one day to the current date

    return this.ConverttoLocalDateInDay(currentDate);
  }
  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    //const visitDateTime = new Date(visitDate);
    const visitDateTime = this.ConverttoLocalDate(visitDate);
    //console.log("visit date time " + visitDateTime);
    ////console.log("visit date time " + typeof visitDateTime);


    const currentDateFormatted = this.getCurrentDateFormatted();
    //console.log("current date with format " + currentDateFormatted)

    const currentDateTime = this.ConverttoLocalDate(currentDateFormatted);
    //console.log("current date time " + currentDateTime);
    ////console.log("current date time "+ typeof currentDateTime);
    const nextDayformated = this.getNextDayFormatted();
    //console.log("next day formated" + nextDayformated)


    const nextDaydate = this.ConverttoLocalDate(nextDayformated);
    //console.log("next day date " + nextDaydate);
    // //console.log("next day date " + typeof nextDaydate);





    if ((visitDateTime == currentDateTime) || (visitDateTime == nextDaydate)) {
      return true;
    } else {
      return false;
    }


    // Compare the year, month, and date components
    //const isSameDate = visitDateTime.getFullYear() === currentDateTime.getFullYear() &&
    //  visitDateTime.getMonth() === currentDateTime.getMonth() &&
    //  visitDateTime.getDate() === currentDateTime.getDate();



    /*
    // Parse the visit date and time into a Date object
    const visitDateTime = new Date(`${visitDate} ${visitTime}`);

    // Get the current date and time
    const currentDateTime = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

    // Convert the difference to hours
    const diffInHours = diffInMs / (1000 * 60 * 60);
    //console.log(" time difference "+diffInHours);
    // Check if the difference is within 24 hours
    return diffInHours <= 24 && diffInHours >= 0; */
  }
  ConverttoLocalDate(date: any): Date {
    // If the input date has a timezone, remove the "Z" character
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    // Use moment to correctly parse the date and retain AM/PM formatting if provided
    const formattedDate = moment(date, ['MM/DD/YYYY h:mm A', 'MM/DD/Y h:mm:ss A']).toDate();

    return formattedDate;
  }



  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }


  ConverttoLocalDateInDay(date: any): string {
    if (date instanceof Date) {
      // Ensure the date is in the local timezone and format without leading zeros
      const month = date.getMonth() + 1; // Months are zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    }
    return date;
  }

  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      //console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      //console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      //console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      //console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }
  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }

  //add to calendar
  addToCalendar() {
    // Define the event details
    const title = this.appointment_details.reasonName + ' Appointment'; //reason + appointment
    const description = this.appointment_details.reasonName + ' Appointment with ' + this.appointment_details?.provid_FName + ' ' + this.appointment_details?.provid_LName; //reason + appointment + with + provider name
    const location = this.appointmentAddress + ', ' + this.appointmentCity + ', ' + this.appointmentState + ' ' + this.appointmentZip; //location
    const appointmentdate = this.appointmentDate;
    const appointTime = this.appointment_details.time_From;

    //console.log("start date ", appointmentdate);
    //console.log("start time ", appointTime);
    //console.log("end date ", this.appointmentEndDate);
    //console.log("end time ", this.appointmentEndTime);
    /// const startDate = new Date(`${appointmentdate} ${appointTime}`); // Use your event start date and time
    const appontDateTimeStr = `${this.appointmentDate} ${appointTime}`;

    const startDate = this.ConverttoLocalDate(appontDateTimeStr); // Use your event start date and time
    //console.log("start date ", startDate);
    // const startDate = new Date('2024-09-04T09:00:00'); // Use your event start date and time

    const appontEndDateTimeStr = `${this.appointmentEndDate} ${this.appointmentEndTime}`;
    const endDate = this.ConverttoLocalDate(appontEndDateTimeStr);
    //console.log("end date ", endDate);
    //const endDate = new Date(`${this.appointmentEndDate} ${this.appointmentEndTime}`)
    // const endDate = new Date('2024-09-04T10:00:00'); // Use your event end date and time

    // Convert dates to the proper format (YYYYMMDDTHHMMSSZ)
    const start = startDate.toISOString().replace(/-|:|\.\d+/g, '');
    const end = endDate.toISOString().replace(/-|:|\.\d+/g, '');

    // Create the .ics file content
    const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Your Organization//Your Product//EN
BEGIN:VEVENT
UID:${new Date().getTime()}@yourdomain.com
DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
DTSTART:${start}
DTEND:${end}
SUMMARY:${title}
DESCRIPTION:${description}
LOCATION:${location}
END:VEVENT
END:VCALENDAR
    `.trim();

    // Create a Blob from the .ics content and download it
    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'event.ics';
    a.click();
    window.URL.revokeObjectURL(url);
  }

}
